import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import ReactHtmlParser from 'react-html-parser';
import {withLocalize} from 'react-localize-redux';

class HomeAbout extends Component {
    render() {
        return (
            <section id="highlight-about" className="highlight-with-images mt-lg-150 mt-md-130 mt-sm-100">
                <div className="row">
                    <div className="col col-images col-12 col-md-5">
                        <Fade bottom>
                            <div className="image image-1 back top right">
                                {this.props.widgets.bloc1_image1 &&
                                    <img src={this.props.widgets.bloc1_image1.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                        <Fade bottom>
                            <div className="image image-2 front bottom left">
                                {this.props.widgets.bloc1_image2 &&
                                    <img src={this.props.widgets.bloc1_image2.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                    </div>
                    <div className="col col-content col-12 col-md-5 offset-0 offset-md-1 align-self-center mt-sm-50">
                        {this.props.widgets.bloc1_titre &&
                            <h3>{ReactHtmlParser(this.props.widgets.bloc1_titre.data.content)}</h3>
                        }
                        {this.props.widgets.bloc1_contenu &&
                            <div className="content">{ReactHtmlParser(this.props.widgets.bloc1_contenu.data.content)}</div>
                        }
                        {this.props.widgets.bloc1_bouton &&
                            <Button variant="contained" color="primary" className="btn-more" component={props => <Link to={this.props.translate('routes.about')} {...props}/>}>
                                {this.props.widgets.bloc1_bouton.data.content}
                            </Button>
                        }
                    </div>
                </div>
            </section>
        );
    }
}

HomeAbout.propTypes = {
    widgets: PropTypes.object.isRequired,
};

export default withLocalize(HomeAbout);



// WEBPACK FOOTER //
// ./src/features/Home/components/HomeAbout.js